import { authClient } from '../services/api.service';
import { AUTH_API_ENDPOINTS } from '../config/api.config';

/** In-flight promise to dedupe concurrent GET /user/entra calls (e.g. Strict Mode, parallel login paths). */
let entraIdentityInFlight: Promise<UserIdentityDto> | null = null;

export interface RoleDto {
  id: number;
  code: string;
  name?: string | null;
  description?: string | null;
}

export interface UserIdentityDto {
  userId: number;
  isActive: boolean;
  roles: RoleDto[];
}

export function clearEntraIdentityInFlight(): void {
  entraIdentityInFlight = null;
}

export const AuthIdentityApi = {
  async getEntraIdentity(headers?: Record<string, string>): Promise<UserIdentityDto> {
    if (entraIdentityInFlight) {
      return entraIdentityInFlight;
    }

    const request = (async (): Promise<UserIdentityDto> => {
      const { data } = await authClient.get<UserIdentityDto>(AUTH_API_ENDPOINTS.userEntra, {
        headers,
      });
      if (!data || typeof data !== 'object' || !('userId' in data)) {
        throw new Error(`AuthService returned unexpected shape from ${AUTH_API_ENDPOINTS.userEntra}`);
      }
      return data;
    })();

    entraIdentityInFlight = request.finally(() => {
      entraIdentityInFlight = null;
    });

    return entraIdentityInFlight;
  },
};
